import useTicketBaseActions from './useTicketBaseActions'

export default useTicketBaseActions
